import {
  createColumn,
  formatNumericCell,
  formatPriceCell,
  getCommonBodyCellProps,
  getCommonFooterCellProps,
  getCommonHeadCellProps,
} from "./commonUtils";
import { formatCurrency } from "../../../utils/dataCalculations";

export const getNukesTableColumns = (theme) => {
  const commonHeadCellProps = getCommonHeadCellProps(theme);
  const commonBodyCellProps = getCommonBodyCellProps(theme);
  const commonFooterCellProps = getCommonFooterCellProps(theme);

  return [
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "Security_Name",
      "Convert_ticker",
      200,
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          Cell: ({ cell }) => cell.getValue() || "-",
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "BB_Ticker_Code_Underlying",
      "Stock Ticker",
      120,
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          Cell: ({ cell }) => cell.getValue() || "-",
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "Cnv_Ratio",
      "Conversion Ratio",
      120,
      "right",
      {
        other: {
          Cell: ({ cell }) => formatPriceCell(cell.getValue(), 4),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "Delta",
      "Delta",
      100,
      "right",
      {
        other: {
          Cell: ({ cell }) => formatPriceCell(cell.getValue(), 2),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "Bond_Anchor",
      "Convert Anchor",
      100,
      "right",
      {
        other: {
          Cell: ({ cell }) => formatPriceCell(cell.getValue(), 4),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "Stock_Anchor",
      "Stock Anchor",
      100,
      "right",
      {
        other: {
          Cell: ({ cell }) => formatPriceCell(cell.getValue(), 4),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "underlying_current_price",
      "Current Stock Price",
      100,
      "right",
      {
        other: {
          Cell: ({ cell }) => formatPriceCell(cell.getValue(), 2),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "underlying_price_change",
      "Stock Px Chg from Nuke",
      110,
      "right",
      {
        other: {
          Cell: ({ cell }) =>
            formatNumericCell(
              cell.getValue(),
              formatCurrency,
              theme.palette.error.main,
              theme.palette.text.primary,
            ),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "current_price",
      "Nuked Price",
      100,
      "right",
      {
        other: {
          Cell: ({ cell }) => formatPriceCell(cell.getValue(), 2),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "last_closing_price",
      "Prior Day Mark",
      100,
      "right",
      {
        other: {
          Cell: ({ cell }) => formatPriceCell(cell.getValue(), 2),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "price_change",
      "Cvt Px Chg from Prior Day",
      100,
      "right",
      {
        other: {
          Cell: ({ cell }) =>
            formatNumericCell(
              cell.getValue(),
              formatCurrency,
              theme.palette.error.main,
              theme.palette.text.primary,
            ),
        },
      },
    ),
  ];
};
